export function sortedIndex(array, value) {
  var low = 0,
    high = array.length;

  while (low < high) {
    var mid = (low + high) >>> 1;
    if (array[mid] < value) low = mid + 1;
    else high = mid;
  }
  return low;
}

export function sortedIndexOf(array, value) {
  const index = sortedIndex(array, value);
  return array[index] === value ? index : -1;
}

export function sortedInsert(array, value) {
  array.splice(sortedIndex(array, value), 0, value);
  return array;
}

export function sortedRemove(array, value, opts) {
  opts = {
    throwOnNotFound: false,
    ...opts,
  };

  const removeIndex = sortedIndexOf(array, value);
  if (removeIndex === -1 && opts.throwOnNotFound) {
    throw new Error('Value not found in array');
  } else if (removeIndex !== -1) {
    array.splice(removeIndex, 1);
  }
  return array;
}

export function sortedSwap(array, removeValue, insertValue, opts) {
  sortedRemove(array, removeValue, opts);
  sortedInsert(array, insertValue);
  return array;
}
